import { Controller } from "@hotwired/stimulus";

// Late/post-purchase baggage add-on form
// (booking/partials/_booking__buy_baggage.html.erb). Each flight leg is
// its own panel with a "Hela resesällskapet" / "Ingen i resesällskapet"
// pair of group toggles alongside one checkbox per passenger -- the same
// three-way-toggle pattern step1/step2 use for their own baggage panels
// (see itinerary_detail_controller.js), simplified here since late
// baggage has at most one real checkbox per passenger per leg (no
// "real vs. group checkbox" split needed for multiple ancillary refs).
export default class extends Controller {
  static targets = ["panel", "allCheckbox", "noneCheckbox", "groupCheckbox", "error"];

  connect() {
    this.panelTargets.forEach((panel) => this.syncGroupToggles(panel));
  }

  toggleAllInPanel(event) {
    const panel = event.currentTarget.closest('[data-late-baggage-target="panel"]');
    const checked = event.currentTarget.checked;
    panel.querySelectorAll('[data-late-baggage-target="groupCheckbox"]').forEach((cb) => { cb.checked = checked; });
    this.syncGroupToggles(panel);
  }

  toggleNoneInPanel(event) {
    const panel = event.currentTarget.closest('[data-late-baggage-target="panel"]');
    if (event.currentTarget.checked) {
      panel.querySelectorAll('[data-late-baggage-target="groupCheckbox"]').forEach((cb) => { cb.checked = false; });
    }
    this.syncGroupToggles(panel);
  }

  // Wired on each passenger's own checkbox so it stays in sync after a
  // manual, one-off change too, not just the two group toggles above.
  syncGroup(event) {
    const panel = event.currentTarget.closest('[data-late-baggage-target="panel"]');
    this.syncGroupToggles(panel);
  }

  syncGroupToggles(panel) {
    const groupCheckboxes = Array.from(panel.querySelectorAll('[data-late-baggage-target="groupCheckbox"]'));
    if (groupCheckboxes.length === 0) return;
    const allChecked = groupCheckboxes.every((cb) => cb.checked);
    const noneChecked = groupCheckboxes.every((cb) => !cb.checked);

    const allCheckbox = panel.querySelector('[data-late-baggage-target="allCheckbox"]');
    const noneCheckbox = panel.querySelector('[data-late-baggage-target="noneCheckbox"]');
    if (allCheckbox) allCheckbox.checked = allChecked;
    if (noneCheckbox) noneCheckbox.checked = noneChecked;
  }

  // Scoped to .ancillary-checkbox (the real, name="baggage[...]" inputs
  // that actually submit) rather than every checkbox in the form -- the
  // "Hela"/"Ingen" group toggles above have no name and don't post, but a
  // blanket input[type=checkbox]:checked selector would still count them.
  submit(event) {
    const checked = this.element.querySelectorAll("input.ancillary-checkbox:checked").length;
    if (checked < 1) {
      event.preventDefault();
      this.errorTarget.classList.remove("hidden");
      setTimeout(() => this.errorTarget.classList.add("hidden"), 2500);
    }
  }
}
